import _extends from "@babel/runtime/helpers/esm/extends";
// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import DiscordFilledSvg from "@ant-design/icons-svg/es/asn/DiscordFilled";
import AntdIcon from "../components/AntdIcon";
var DiscordFilled = function DiscordFilled(props, ref) {
  return /*#__PURE__*/React.createElement(AntdIcon, _extends({}, props, {
    ref: ref,
    icon: DiscordFilledSvg
  }));
};
if (process.env.NODE_ENV !== 'production') {
  DiscordFilled.displayName = 'DiscordFilled';
}
export default /*#__PURE__*/React.forwardRef(DiscordFilled);